import { Injectable } from '@angular/core';
import {ref, uploadBytesResumable, UploadTask, getDownloadURL, getStorage, deleteObject} from 'firebase/storage';
import firebase from "firebase/compat/app";
import {
  Firestore,
  collection,
  CollectionReference,
  addDoc,
  doc,
  setDoc,
  deleteDoc,
  getFirestore, onSnapshot
} from "@angular/fire/firestore";
import {FileRef} from "../model/file-ref";
import {Observable} from "rxjs";
import Timestamp = firebase.firestore.Timestamp;

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private storage: any;
  private filesRef: CollectionReference<FileRef> | undefined;

  constructor(
    private afs: Firestore,
  ) {
    this.storage = getStorage();
    this.filesRef = collection(this.afs, 'uploads') as CollectionReference<FileRef>;
  }

  public uploadFile(file: File): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const uid: string = doc(this.filesRef).id;
      const storageRef = ref(this.storage, uid);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on('state_changed', null,
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(url => {
              setDoc(doc(this.filesRef, uid), {
                  uid: uid,
                  name: file.name,
                  url: url,
                  ref: uploadTask.snapshot.ref.fullPath,
                  size: file.size,
                  uploaded: Timestamp.now(),
              }).then(() => {
                resolve();
              }).catch(error => {
                reject(error);
              });
          }).catch(error => {
            reject(error);
          });
      });
    });
  }

  public getFiles(): Observable<FileRef[]> {
    return this.filesRef
      ? new Observable<FileRef[]>(observer => {
          const firestore = getFirestore();
          const unsubscribe = onSnapshot(collection(firestore, 'uploads'), snapshot => {
            const files: FileRef[] = snapshot.docs.map(doc => doc.data() as FileRef);
            observer.next(files);
          }, error => observer.error(error));

          return { unsubscribe };
        })
      : new Observable<FileRef[]>(observer => observer.complete());
  }

  public deleteFile(file: FileRef) {
    deleteDoc(doc(this.filesRef, file.uid)).then(() => {
      const storageRef = ref(this.storage, file.ref);
      deleteObject(storageRef);
    })
  }
}
